import React from 'react'
// import BsYoutube from 'react-icons/bs'
import './Footer.css'

const Footer = () => {
    return (
        <section id="footer">
            <div className="footer_container">
                <div className="row">
                    <div className="copy-r">
                        <p>&copy; 2022 - all rights reserved, Resume-Builder.</p>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Footer